<template>
    <div class="col-md-12" style="height: 100%;overflow-y: auto;">
        <div class="row" style="padding-top: 15px; padding-bottom: 15px; margin-bottom: 15px;">
            <div class="col-md-10">
            </div>
            <div class="col-md-2">
                <ob-date-time-picker id="createDate" placeholder="Select Date" :options="options1" :inputvalue="Year" @updated="(v) => this. Year = v" v-model.trim="Year"></ob-date-time-picker>
            </div>
        </div>
        <div class="row">
             <div class="col-md-6">
                   <div>
                        <p class="section-holder__value">{{LeaveData.TotalLeaveCount}} day(s)</p>
                        <p class="section-holder__label">Total Leaves</p>

                        <p style="font-weight: 600;margin:12px 0"> A graphical representation of your leaves based on their types.</p>

                        <p style="font-style: italic;margin:12px 0">Choose one of the following options to view the corresponding data.</p>
                 </div>
                 <div style="margin:12px 0">
                   <span class="leave-buttons" :class="ApprovedLeaves && !BalanceLeaves? 'leave-buttons-selected': ''" @click="onAppliedLeavesClick">
                      <span style="font-weight: 700;font-size: 15px;"> {{AppliedLeavesSum}} </span>Taken
                  </span>
                   <span class="leave-buttons" :class="!ApprovedLeaves && BalanceLeaves? 'leave-buttons-selected': ''" style="" @click="onBalancedLeavesClick">
                      <span style="font-weight: 700;font-size: 15px;"> {{BalanceLeavesSum}} </span>Balance
                  </span>
                  <span class="leave-buttons" :class="!ApprovedLeaves && !BalanceLeaves && PendingLeaves? 'leave-buttons-selected': ''" style="" @click="onPendingLeavesClick">
                      <span style="font-weight: 700;font-size: 15px;"> {{PendingLeavesSum}} </span>Pending
                  </span>
                 </div>
            </div>
             <div class="col-md-6">
                  <template v-if="DoughnutChartData.length > 0">
                       <chart  :doughnutChartdata.sync="DoughnutChartData"> </chart>
                  </template>
                  <template v-else>
                        <div  class="text-center" v-if="IsAjaxCallCompleted">
                            <div style="margin-bottom: 20px">
                                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_nodata.svg`">
                            </div>
                            <div style="font-size: 14px;">No data available to display!</div>
                        </div>
                  </template>
            </div>
        </div>
    </div>
</template>
<script>
import c from 'Vue/Core/constants.js'
import utils from "Vue/Core/utils.js";
import chart from "./Chart.vue";

export default {
  props: ["content"],
  data() {
  return {
      UnPaidLeaveCount :0,
      ApprovedLeaves : true,
      BalanceLeaves : false,
      PendingLeaves : false,
      LeaveData : '',
      DoughnutChartData: [],
      Year:moment().format("YYYY"),

      options1: {
        format: 'YYYY',
        minDate: moment('01/01/1970').format('MM/DD/YYYY'),
        // maxDate: moment().add(10, 'years'),
        dayViewHeaderFormat: 'YYYY',
        ignoreReadonly: true,
        widgetPositioning: {
        horizontal: 'right',
        vertical: 'bottom'
        }
      },
      IsAjaxCallCompleted:false
    }
  },
  components: {
    'chart':chart
  },
  watch:{
    Year(val)
    {
      if(val != null && val != ''){
        this.getLeaveCount(val)
      }
    }
  },
  computed: {
    EmployeeId() {
      if(this.$route.query.EmployeeId){
        return this.$route.query.EmployeeId
      }
      else
        return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    },
    BalanceLeavesSum()
    {
      if(this.LeaveData && this.LeaveData.BalanceLeaves)
      {
        let result = this.LeaveData.BalanceLeaves.map(a => a.Count);
        let balanceLeavesSum = result.reduce(function(a, b) { return a + b; }, 0);
          return balanceLeavesSum
      } else return 0
    },
    AppliedLeavesSum()
    {
      if(this.LeaveData && this.LeaveData.ApprovedLeaves)
      {
        let result = this.LeaveData.ApprovedLeaves.map(a => a.Count);
        let appliedLeaves = result.reduce(function(a, b) { return a + b; }, 0);
          return appliedLeaves
      } else return 0
    },
    PendingLeavesSum()
    {
      if(this.LeaveData && this.LeaveData.PendingLeaves)
      {
        let result = this.LeaveData.PendingLeaves.map(a => a.Count);
        let pendingLeaves = result.reduce(function(a, b) { return a + b; }, 0);
          return pendingLeaves
      } else return 0
    }
  },
  created()
  {
    var currentYear = moment().format("YYYY")
    this.getLeaveCount(currentYear)
  },
  methods: {
    onAppliedLeavesClick()
    {
      this.DoughnutChartData = [] ;
      this.ApprovedLeaves = true ;
      this.BalanceLeaves = false ;
      this.PendingLeaves = false ;
      if(this.AppliedLeavesSum > 0)
      {
      this.DoughnutChartData = this.LeaveData.ApprovedLeaves.filter(v=>v.Count != 0) ;
      }
    },
      onBalancedLeavesClick()
    {
      this.DoughnutChartData = [] ;
      this.ApprovedLeaves = false ;
      this.BalanceLeaves = true ;
      this.PendingLeaves = false ;
      if(this.BalanceLeavesSum > 0)
      {
        this.DoughnutChartData = this.LeaveData.BalanceLeaves.filter(v=>v.Count != 0);
      }
    },
    onPendingLeavesClick()
    {
      this.DoughnutChartData = [] ;
      this.ApprovedLeaves = false ;
      this.BalanceLeaves = false ;
      this.PendingLeaves = true ;
      if(this.PendingLeavesSum > 0)
      {
        this.DoughnutChartData = this.LeaveData.PendingLeaves.filter(v=>v.Count != 0);
      }
    },
    getLeaveCount(year)
    {
        this.IsAjaxCallCompleted = false
        this.$loading({'loadingText': 'Loading...'})
        ajax.get(`/Leave/${this.EmployeeId}/${year}/Count`, {}, (res) => {
            this.LeaveData = res.data.LeaveData;
            // if(this.LeaveData != null && this.LeaveData.ApprovedLeaves != null)
            // {
            //     var unpaidLeave = this.LeaveData.ApprovedLeaves.filter(v=>v.Key == "unpaid");
            //     if(unpaidLeave.Count > 0)
            //     {
            //         this.UnPaidLeaveCount = unpaidLeave[0].Count
            //     }
            // }
            this.onAppliedLeavesClick()
            this.$loading({}).close()
              this.IsAjaxCallCompleted = true
        })
    }
  }
}
</script>
<style scoped>

.control-label {
    color: #8695A5;
}
.form-control-static {
    color: #475259;
    font-weight: 600;
}
.section-title {
    color: #4D92DF;
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.section{
    color: rgb(103, 106, 108);
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.label {
    border-radius: 10px;
}
.section-holder__value{
    color: #123261;
    font-size: 28px;
    font-weight: 700;
    line-height: 50px;
}
.section-holder__label{
    font-size: 14px;
    font-weight: 600;
}
.leave-buttons{
    padding: 10px;
    display: inline-block;
    margin: 4px 0;
    cursor: pointer;
    font-size: 12px;
}
.leave-buttons-selected{
    background: #4A90E2;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/LeaveCount.vue